import { Capacitor } from '@capacitor/core';

const mobileRoutingEnv = process.env.REACT_APP_MOBILE_ROUTING;
const mobileRoutingExplicitOn =
  mobileRoutingEnv === 'true' ||
  mobileRoutingEnv === '1' ||
  String(mobileRoutingEnv ?? '').toLowerCase() === 'yes';
const mobileRoutingExplicitOff =
  mobileRoutingEnv === 'false' ||
  mobileRoutingEnv === '0' ||
  String(mobileRoutingEnv ?? '').toLowerCase() === 'no';

const mobileRouting =
  mobileRoutingExplicitOn ||
  (!mobileRoutingExplicitOff && Capacitor.isNativePlatform());

const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  environment: process.env.REACT_APP_ENVIRONMENT,
  mobileRouting,
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  wsUrl: process.env.REACT_APP_WS_URL,
  paymentReturnUrl: process.env.REACT_APP_PAYMENT_RETURN_URL,
  version: process.env.REACT_APP_VERSION,

  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  firebaseStorageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  firebaseMessagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID,
  firebaseMeasurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  firebaseWebPushVapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
};

export default config;
